var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"subTable",staticClass:"text-area"},_vm._l((_vm.theText),function(t,i){return _c('p',{key:i,domProps:{"innerHTML":_vm._s(t)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }